import { useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { ArrowLeft, ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";
import { usePageContent } from "../hooks/usePageContent";
import { SEO } from "../components/SEO";

function FaqItem({ item }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-[#E6E2DD]" data-testid="faq-item">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between py-6 text-left" data-testid="faq-toggle">
        <span className="text-sm tracking-wide pr-4" style={{ fontFamily: "'Playfair Display', serif" }}>{item.q}</span>
        <ChevronDown size={16} strokeWidth={1.5} className={`text-[#9CA3AF] flex-shrink-0 transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <p className="text-sm text-[#1A1A1A]/70 leading-relaxed tracking-wide pb-6 pr-8">{item.a}</p>}
    </div>
  );
}

export default function FaqPage() {
  const { t } = useLanguage();
  const { data, loading } = usePageContent("faq");

  if (loading) return <div className="px-6 md:px-12 lg:px-24 py-20"><p className="text-sm text-[#9CA3AF]">{t("common.loading")}</p></div>;

  const items = data?.faq_items || [];

  return (
    <div className="px-6 md:px-12 lg:px-24 py-12 md:py-20 max-w-3xl" data-testid="faq-page">
      <SEO title="FAQ" description="Frequently asked questions about Mona Luxe. Learn about authentication, shipping, returns, and buying pre-owned designer bags." path="/faq" />
      <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-[#9CA3AF] hover:text-[#1A1A1A] transition-colors mb-10">
        <ArrowLeft size={14} strokeWidth={1.5} /> {t("common.back")}
      </Link>
      <h1 className="text-3xl md:text-4xl mb-4" style={{ fontFamily: "'Playfair Display', serif" }} data-testid="faq-title">
        {data?.title || t("footer.faq")}
      </h1>
      {data?.subtitle && <p className="text-sm text-[#9CA3AF] tracking-wide mb-12">{data.subtitle}</p>}

      <div>
        {items.map((item, i) => <FaqItem key={i} item={item} />)}
      </div>

      <div className="mt-12 p-8 bg-[#F4F0EB]">
        <p className="text-sm tracking-wide mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>Still have questions?</p>
        <p className="text-xs text-[#9CA3AF] tracking-wide mb-4">Our team is happy to help.</p>
        <Link to="/contact" className="btn-luxury text-[10px]" data-testid="faq-contact-link">{t("footer.contact")}</Link>
      </div>
    </div>
  );
}
